import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { TARGET_AUDIENCE } from '../../constants';

export const { Types, Creators } = createActions({
  pubAlvoInit: [],
  pubAlvoRequest: [],
  pubAlvoSuccess: ['context', 'data'],
  pubAlvoError: ['err'],
  getPubAlvos: ['filter']
});

/** --------------------------------
 * Variable declarations
 * --------------------------------- */

const INITIAL_STATE = Immutable({
  data: [],
  [TARGET_AUDIENCE]: [],
  loading: false,
  error: false
});

/* Reducers Product */

export const init = state => state.merge({ data: [] });

export const request = state => state.merge({ loading: true });

export const success = (state, { context, data }) => state.merge({ [context]: data, error: false, loading: false });

export const error = state => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.PUB_ALVO_INIT]: init,
  [Types.PUB_ALVO_REQUEST]: request,
  [Types.PUB_ALVO_SUCCESS]: success,
  [Types.PUB_ALVO_ERROR]: error
});